import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "slideItem", "prevBtn", "nextBtn"];

  GAP = 24; // 1.5rem gap in pixels
  next() {
    if (this.canScrollNext()) {
      const slideWidth = this.getSlideWidth();
      this.containerTarget.scrollBy({
        left: slideWidth + this.GAP,
        behavior: "smooth",
      });
    }
  }

  previous() {
    if (this.canScrollPrevious()) {
      const slideWidth = this.getSlideWidth();
      this.containerTarget.scrollBy({
        left: -(slideWidth + this.GAP),
        behavior: "smooth",
      });
    }
  }

  getSlideWidth() {
    const firstSlide = this.slideItemTargets[0];
    return firstSlide ? firstSlide.offsetWidth : 0;
  }

  canScrollPrevious() {
    return this.containerTarget.scrollLeft > 0;
  }

  canScrollNext() {
    const container = this.containerTarget;
    const maxScroll = container.scrollWidth - container.clientWidth;
    return container.scrollLeft < maxScroll - 1; // -1 for floating point precision
  }
}
